import { HouseFeature } from '@/types/house.types';

type NextEnabledFeaturesOptions = Readonly<{
    crossListing: boolean;
}>;

export const nextEnabledFeatures = (
    current: readonly HouseFeature[],
    { crossListing }: NextEnabledFeaturesOptions
): HouseFeature[] => {
    if (crossListing && current.includes(HouseFeature.CROSS_LISTING)) {
        return [...current];
    }

    const withoutCrossListing = current.filter((feature) => feature !== HouseFeature.CROSS_LISTING);

    return crossListing ? [...withoutCrossListing, HouseFeature.CROSS_LISTING] : withoutCrossListing;
};
